import {antiForgeryPost} from '../../utils/fetch';

const fetchWalletAccountData = {
    getCustomerPaymentMethods: async function () {
        const response = await fetch('/api/Wallet/GetCustomerPaymentMethods');
        return await response.json();
    },
    getCartPaymentMethod: async function () {
        const response = await fetch('/api/Wallet/GetCartPaymentMethod');
        return await response.json();
    },
    canRemoveWalletItem: async function (walletItemId) {
        const response = await fetch(`/api/Wallet/CanRemoveWalletItem?walletItemId=${walletItemId}`);
        return await response.json();
    },
    saveCartPaymentMethod: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/SaveCartPaymentMethod', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    saveCreditCardWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/SaveCreditCardWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    saveSubscriptionPaymentMethod: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/SaveSubscriptionPaymentMethod', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    savePayPalWalletItem: async function () {
        const response = await antiForgeryPost('/api/Wallet/SavePayPalWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    },
    saveApplePayWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/SaveApplePayWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        return await response.json();
    },
    deleteCreditCardWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/DeleteCreditCardWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    deleteNonPaymentWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/DeleteNonPaymentWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    saveNonPaymentWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/SaveNonPaymentWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    deletePayPalWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/DeletePayPalWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    deleteApplePayWalletItem: async function (data) {
        const response = await antiForgeryPost('/api/Wallet/DeleteApplePayWalletItem', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    },
    setWalletItemAsDefault: async function (walletItemId) {
        const response = await fetch(`/api/Wallet/SetWalletItemAsDefault?walletItemId=${walletItemId}`);
        return await response.json();
    },
    rechargePayment: async function (data) {
        const response = await fetch('/api/Wallet/RechargeAllPayments', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    }
};

export default fetchWalletAccountData;
